import { Container } from 'pixi.js';
import { Tween, Easing } from '@tweenjs/tween.js';
import { SplashScreenView } from './view/splash-screen/SplashScreenView';
import Ui from './ui/Ui';
import Reels from './reels/Reels';
import ViewTransitions from './helpers/animations/ViewTransitions';
import { GameConfigs } from './lib/globals/GameConfigs';
import Modal from './helpers/Modal';
import serverMSG from './helpers/gameHandlers/serverMsg';
import addViews from './helpers/gameHandlers/addViews';
import {
	addEventListeners,
	removeEventListeners
} from './helpers/gameHandlers/addEventListeners';
import handleBonusRound, {
	initSamuraiSplashScreen
} from './helpers/gameHandlers/handleBonusRound';
import winHighlight from './helpers/gameHandlers/winHightlight';
import { COMPONENTS, EVENTS } from './lib/constants';
import HELPERS from './lib/globals/helpers/Helpers';
// import TimerController from './controllers/TimerController';
import { FreespinPromptView } from './view/freespin/FreespinPromptView';
import { FreespinWinView } from './view/freespin/FreespinWinView';
// import { createStars } from "./helpers/background/StarsBg";
import { BonusGameDialogueView } from './view/bonus-game/BonusGameDialogueView';
import { WinHighlight } from './view/win-highlight/WinHighlightView';
import Layer from './helpers/background/Layer';

class Game extends Container {
	constructor() {
		super();
		this.init = true;
		this.layer = new Layer();
		// createStars(this, GameConfigs.Pixi.ticker, GameConfigs.Pixi);
		//ADD REELS
		this.reels = new Reels(GameConfigs.ReelConfig);
		this.reels.alpha = 1;
		//ADD UI
		this.ui = new Ui();
		this.addChild(this.ui);

		this.modal = new Modal(this.ui, this.layer);
		this.viewTransitions = new ViewTransitions(this.ui, this.reels);
		GameConfigs.reelComponent = this.reels;

		GameConfigs.uiComponent = this.ui;
		// this.timeController = new TimerController(GameConfigs.quest.seconds_left);
		//ADD SPLASH SCREEN
		this.bgMusic_idle = true;
		this.bgMusic_in_game = false;
		this.bgMusic_bonus = false;

		// init samurai animation for preloading bonus game
		initSamuraiSplashScreen(this);

		if (GameConfigs.settings.splash_screen) {
			this.splash = new Ui();
			this.splash.addView(SplashScreenView);
			this.addChild(this.splash);
			GameConfigs.splashComponent = this.splash;
		} else {
			addViews(this);

			GameConfigs.uiComponent[COMPONENTS.REEL].getChildByName(
				'reel_bg_1',
				true
			).handler = this.handleReelEvent.bind(this);
			this.checkBonus();
		}

		addEventListeners(this);
	}

	handleReelEvent() {
		if (this.reels.rotating) {
			this.reels.fastStop();
		}
	}

	simulateReelRotation() {
		setTimeout(() => {
			if (GameConfigs.bonusRestore) {
				if (GameConfigs.bonusRestore.bonusround) {
					if (GameConfigs.modal === 'bonus_game') {
						HELPERS.dispatchCustomEvent(EVENTS.MODAL, { modal: '' });
					}
					GameConfigs.bonusRoundActivated = 'started';
					HELPERS.dispatchCustomEvent(EVENTS.BONUS_ROUND_STATE, {
						state: 'started'
					});
					if (this.reels.rotating) {
						setTimeout(() => {
							this.reels.stop(
								GameConfigs.bonusRestore.bonusround,
								GameConfigs.settings.fast_spin
							);
						}, 1000);
					}
				} else {
					// console.log('REELS START')
					this.reels.start();
					if (this.reels.rotating) {
						setTimeout(() => {
							this.reels.stop(
								GameConfigs.bonusRestore.spinresult,
								GameConfigs.settings.fast_spin
							);
						}, 1000);
					}
				}
			}
		}, 500);
	}

	checkBonus() {
		if (GameConfigs.config.hasbonus) {
			this.bgMusic_idle = false;
			this.bgMusic_bonus = true;
			this.reels.start();
			// console.log('simulat reel')
			this.simulateReelRotation();
			// }
		}
	}

	handleEvent(evt) {
		switch (evt.type) {
			case EVENTS.ERROR_PAGE:
				window.sm.mute();
				if (GameConfigs.modal !== '') {
					HELPERS.dispatchCustomEvent(EVENTS.MODAL, { modal: '' });
				}
				removeEventListeners(this);
				break;
			case EVENTS.SERVER_MSG:
				serverMSG(evt.detail);
				break;
			case EVENTS.MAIN_LINE_FINISHED:
				this.handleWin();
				// lineAllfinished();
				// HELPERS.dispatchCustomEvent(EVENTS.BET_PLACED, { placed: false });
				// console.log("main line finished", GameConfigs.bonusRoundActivated);
				break;
			case EVENTS.SETTINGS_UPDATE:
				// console.log(evt.detail, "event detail˝");
				if (evt.detail.data.background_music === undefined) return;
				if (evt.detail.data.background_music) {
					if (GameConfigs.bonusBuy) {
						if (this.bgMusic_bonus) {
							window.sm.play({
								name: 'bg_music_lvl3',
								loop: true,
								background: true
							});
						}
					} else {
						if (this.bgMusic_idle) {
							window.sm.play({
								name: 'bg_music_lvl1',
								loop: true,
								background: true
							});
						}
						if (!this.bgMusic_idle && this.bgMusic_in_game) {
							this.bgMusic_idle = true;
							this.bgMusic_in_game = false;
							window.sm.play({
								name: 'bg_music_lvl1',
								loop: true,
								background: true
							});
							window.sm.stop('bg_music_lvl2', 500);
						}
					}
				} else {
					window.sm.stop('bg_music_lvl1', 1000);
					window.sm.stop('bg_music_lvl2', 1000);
					window.sm.stop('bg_music_lvl3', 1000);
					window.sm.stop('bg_music_lvl4', 1000);
				}

				break;
			case EVENTS.BET_PLACED:
				GameConfigs.betPlaced = evt.detail.placed;
				if (evt.detail.placed) {
					if (GameConfigs.settings.background_music) {
						this.playBackgroundMusic();
					}
					this.reels.start();
				}
				break;
			case EVENTS.HAS_QUEST:
				GameConfigs.hasQuest = evt.detail.hasQuest;
				break;
			case EVENTS.REEL_FINISHED:
				if (
					GameConfigs.freeSpinLocal.status === 'completed' &&
					!GameConfigs.freeSpinLocal.hasBonus
				) {
					this.ui.addView(FreespinWinView);
					HELPERS.disableAllButtons(true);
					HELPERS.dispatchCustomEvent(EVENTS.MODAL, { modal: 'freespin_win' });
					if (GameConfigs.autospin.isAutoOn) {
						GameConfigs.autospin.isAutoOn = false;
						GameConfigs.autospin.pause = false;
						HELPERS.dispatchCustomEvent(EVENTS.AUTO_STARTED, {
							numOfBets: GameConfigs.autospin.numOfBets,
							isAutoOn: false,
							leftBets: 0,
							pause: false
						});
					}
				}
				break;
			case EVENTS.FREESPIN:
				if (this.splash) return;
				if (evt.detail.freespin.hasBonus) {
					// console.log(evt.detail.freespin);
				} else {
					console.log(evt.detail, 'event detail');
					if (evt.detail.freespin.show && !evt.detail.freespin.start) {
						this.ui.addView(FreespinPromptView);
						HELPERS.dispatchCustomEvent(EVENTS.MODAL, {
							modal: 'freespin_prompt'
						});
					}
				}

				break;
			case EVENTS.MODAL:
				this.modal.modalChanged(evt);
				break;
			case EVENTS.ALL_LINES_FINISHED:
				HELPERS.dispatchCustomEvent(EVENTS.BET_PLACED, { placed: false });
				break;
			case EVENTS.WIN_HIGHLIGHT:
				if (evt.detail.open) {
					window.sm.play({
						name: 'bg_music_lvl4',
						fade: 500,
						background: true
					});
					if (GameConfigs.settings.background_music) {
						if (this.bgMusic_idle) {
							window.sm.stop('bg_music_lvl1', 500);
							this.bgMusic_idle = false;
						}
						if (this.bgMusic_bonus) {
							this.bgMusic_bonus = false;
							window.sm.stop('bg_music_lvl3', 500);
						}
						if (this.bgMusic_in_game) {
							if (this.timeout_1) {
								clearTimeout(this.timeout_1);
							}
							if (this.timeout_2) {
								clearTimeout(this.timeout_2);
							}
							window.sm.stop('bg_music_lvl2', 500);
							this.bgMusic_in_game = false;
						}
					}
				} else {
					window.sm.stop('bg_music_lvl4', 1000);
					if (GameConfigs.settings.background_music) {
						if (GameConfigs.bonusBuy && !this.bgMusic_bonus) {
							window.sm.play({
								name: 'bg_music_lvl3',
								loop: true,
								background: true,
								fade: 1000
							});
							this.bgMusic_bonus = true;
						} else {
							window.sm.play({
								name: 'bg_music_lvl1',
								loop: true,
								background: true,
								fade: 500
							});
							this.bgMusic_idle = true;
						}
					}
					winHighlight(evt.detail.open);
				}

				break;
			case EVENTS.BONUS_ROUND_STATE:
				handleBonusRound(evt.detail.state, this);
				break;
			case EVENTS.START_GAME:
				if (this.splash) {
					new Tween(this.splash)
						.to({ alpha: 0 }, 100)
						.easing(Easing.Linear.None)
						.onComplete(() => {
							addViews(this);
							GameConfigs.uiComponent[COMPONENTS.REEL].getChildByName(
								'reel_bg_1',
								true
							).handler = this.handleReelEvent.bind(this);
							if (GameConfigs.config.hasbonus && this.init) {
								this.simulateReelRotation();
								this.init = false;
							}
							if (GameConfigs.isFreeSpin) {
								this.ui.addView(FreespinPromptView);
								HELPERS.dispatchCustomEvent(EVENTS.MODAL, {
									modal: 'freespin_prompt'
								});
							}
						})
						.start();
				}
				break;
			default:
				break;
		}
	}

	handleWin() {
		const err =
			GameConfigs.notification.code === 0 && GameConfigs.errors.code === 0;
		if (GameConfigs.win > 0 && err) {
			if (HELPERS.getWinLevels().length > 0 && GameConfigs.modal !== 'win') {
				HELPERS.disableAllButtons(true);
				HELPERS.dispatchCustomEvent(EVENTS.MODAL, { modal: 'win' });
				GameConfigs.modal = 'win';
				HELPERS.dispatchCustomEvent(EVENTS.WIN_HIGHLIGHT, { open: true });
				this.ui.addView(WinHighlight);
				if (GameConfigs.bonusBuy && GameConfigs.bonusRoundActivated === '') {
					GameConfigs.bonusRoundActivated = 'pending';
					HELPERS.dispatchCustomEvent(EVENTS.BONUS_ROUND_STATE, {
						state: 'pending'
					});
				}
			} else {
				if (GameConfigs.bonusBuy && GameConfigs.bonusRoundActivated === '') {
					window.sm.play({ name: 'mini_win_sfx' });
					// HELPERS.disableAllButtons(true);
					setTimeout(() => {
						GameConfigs.bonusRoundActivated = 'init';
						HELPERS.dispatchCustomEvent(EVENTS.BONUS_ROUND_STATE, {
							state: 'init'
						});
						GameConfigs.modal = 'bonus_game';
						HELPERS.dispatchCustomEvent(EVENTS.MODAL, { modal: 'bonus_game' });
						GameConfigs.uiComponent.addView(BonusGameDialogueView);
					}, 1500);
				}
			}
		}
	}

	playBackgroundMusic() {
		clearTimeout(this.timeout_1);
		if (this.bgMusic_idle) {
			window.sm.stop('bg_music_lvl1', 1000);
			this.bgMusic_idle = false;
			if (!this.bgMusic_in_game) {
				window.sm.play({
					name: 'bg_music_lvl2',
					loop: true,
					background: true,
					fade: 500
				});
				this.bgMusic_in_game = true;
				this.timeout_1 = setTimeout(() => {
					window.sm.stop('bg_music_lvl2', 1000);
					this.bgMusic_in_game = false;
					window.sm.play({
						name: 'bg_music_lvl1',
						loop: true,
						background: true,
						fade: 500
					});
					this.bgMusic_idle = true;
				}, 15000);
			}
		} else if (this.bgMusic_in_game) {
			clearTimeout(this.timeout_1);
			clearTimeout(this.timeout_2);
			this.timeout_2 = setTimeout(() => {
				window.sm.stop('bg_music_lvl2', 1000);
				this.bgMusic_in_game = false;
				window.sm.play({
					name: 'bg_music_lvl1',
					loop: true,
					background: true,
					fade: 500
				});
				this.bgMusic_idle = true;
			}, 15000);
		}
	}

	resize() {
		// this.bg.resize();
		if (this.layer) {
			this.layer.resize();
		}
		if (this.samurai) {
			this.samurai.resize();
			//   if (this.samurai_anim.visible) {
			let sx = window.innerWidth / this.samurai_width;
			let sy = window.innerHeight / this.samurai_height;

			let s = Math.max(sx, sy);
			this.samurai_anim.scale.set(s);
			this.samurai_anim.x = window.innerWidth / 2;
			this.samurai_anim.y = window.innerHeight / 2;
			//   }
		}
		if (this.ui) {
			this.ui.resize(window.CurrentSize.w, window.CurrentSize.h);
		}
		if (this.splash) {
			this.splash.resize(window.CurrentSize.w, window.CurrentSize.h);
		}
	}
}

export default Game;
